/// <reference types="@types/googlemaps" />
import { Component, AfterViewInit, ViewChild, ElementRef, Input, OnInit } from '@angular/core';
import { PropertyInterface } from 'app/interface/property';
import { MFYardiProperty } from 'app/models/mfYardiProperty';
import { ApplicationDataService } from 'services/application.service';
import { ErrorService } from 'services/error.service';

declare let google: any;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})

export class MapComponent extends google.maps.OverlayView implements OnInit, AfterViewInit {
  @Input()   mapLocations: string[] = [];
  @Input()   mfMapLocations: MFYardiProperty[] = [];
  @ViewChild('gmapContainer', {static: false}) gmap: ElementRef;
  map: google.maps.Map;
  infowindow: google.maps.InfoWindow;
  bounds  = new google.maps.LatLngBounds();
  propertyCount = 0;

  constructor(private applicationService: ApplicationDataService, private errorService: ErrorService) {
    super();
  }

  ngOnInit(): void {
  }

  //Coordinates to set the center of the map on United States
  coordinates = new google.maps.LatLng(39.5, -98.35);

  mapOptions: google.maps.MapOptions = {
    center: this.coordinates,
    zoom: 4,
    mapTypeId: google.maps.MapTypeId.ROADMAP
  };

  mapInitializer() {
    this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);
    this.infowindow = new google.maps.InfoWindow();
    this.createMarkers();
   }

  createMarkers() {
    for(const mfMapLocation of this.mfMapLocations){
      this.applicationService.getMFProperty(mfMapLocation.YardiKey, mfMapLocation.YardiUnitCode).subscribe(res => this.createMarker(res), err => this.errorService.showError(err));
    }
    for(const mapLocation of this.mapLocations){
      this.applicationService.getProperty(mapLocation).subscribe(res => this.createMarker(res), err => this.errorService.showError(err));
    }
  };

  createMarker(prop: PropertyInterface){
    if (prop.results && prop.results[0])
    {
      //Create Marker
      var pinSVGHole = "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z";

      var markerImage = {
        path: pinSVGHole,
        anchor: new google.maps.Point(12,17),
        fillOpacity: 1,
        fillColor: "#232D65",
        strokeWeight: 2,
        strokeColor: "white",
        scale: 2
      };

      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(prop.results[0].lat, prop.results[0].lng),
        map: this.map,
        title: prop.results[0].title,
        icon: markerImage
      });

      //Expand map to include marker
      const loc = new google.maps.LatLng(prop.results[0].lat, prop.results[0].lng);
      this.bounds.extend(loc);

      //Setup Marker Content
      let rent = "";

      if ((prop.results[0].min_rent != null && prop.results[0].max_rent != null) && (prop.results[0].min_rent == prop.results[0].max_rent)) {
        rent = prop.results[0].min_rent.toLocaleString().toLocaleString();
      }
      else if (prop.results[0].min_rent != null && prop.results[0].max_rent != null) {
        rent = prop.results[0].min_rent.toLocaleString() + '-$'+ prop.results[0].max_rent.toLocaleString();
      }
      else {
        rent = prop.results[0]?.rent?.toLocaleString();
      }

      let sqft = "";
      if(prop.results[0].sqft){
        sqft = prop.results[0].sqft.toLocaleString();
      }

      var content =
      '<div id="iw-container">' +
        '<div class="iw-content">' +
          '<div class="column md:flex">' +
            '<div>' +
              `<img src=${prop.results[0].thumb} width="100">` +
            '</div>' +
            '<div class="ml-2">' +
              `<b class="text-lg">$${rent}</b>/mo` +
              `<br><b>${prop.results[0].beds}</b> bd    |    <b>${prop.results[0].baths}</b> ba    |    <b>${sqft}</b> sqft` +
              `<br>${prop.results[0].street}, ${prop.results[0].region}` +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

      //Add on click listener
      marker.addListener("click", () => {
        this.infowindow.setContent(content);
        this.infowindow.open(marker.getMap(), marker);
      });
    }
    this.propertyCount ++;

    if(this.propertyCount == (this.mapLocations.length + this.mfMapLocations.length)){
      this.mapFitBound();
    }
  };

  mapFitBound(){
    //Zoom and fit map around markers
    this.map.fitBounds(this.bounds);
    this.map.panToBounds(this.bounds);
  }

  ngAfterViewInit(): void {
    this.mapInitializer();
  }
}
